import PlateLayout from "./PlateLayout"

export default PlateLayout;